<template>
<!--  <h2>-->
<!--    Getting Started-->
<!--  </h2>-->
<!--  <p>-->
<!--    This document introduced how to successfully call the BGNN API to get multimedia metadata and associated metadata, like Image Quality metadata. It assumes you are familiar with BGNN API and know how to perform REST API calls.-->
<!--  </p>-->
<!--  <h3>-->
<!--    Before Starting-->
<!--  </h3>-->
<!--  <p>An API key is a encrypted string that you can use when calling BGNN APIs. You can apply it by email xwang48@tulane.edu</p>-->
<h2>coming soon...</h2>

</template>

<script>
export default {
  name: "APIInfo"
}
</script>

<style scoped>
h1,h2,h3,h4,h5,h6{
  color:#9f0809
}
</style>